export default __webpack_public_path__ + "static/media/c002-PPII-9.64d650d2.svg";